import { z } from "zod";
import { ResourceSchema } from "../../../resources";
const pixelLength = z.object({
  value: z.number(),
  unit: z.literal("px")
});
const percentageLength = z.object({
  value: z.number(),
  unit: z.literal("%")
});
const borderStyle = z.enum(["dotted", "dashed", "solid"]);
const borderSideSchema = (color) => z.object({
  width: z.number().nullable().optional(),
  style: borderStyle,
  color: color.nullable().optional()
}).transform((v) => ({
  ...v,
  width: v.width
}));
const borderSide = borderSideSchema(ResourceSchema.colorData);
const resolvedBorderSide = borderSideSchema(
  ResourceSchema.resolvedColorData
);
const borderSchema = (color) => z.object({
  borderTop: borderSideSchema(color).nullable().optional(),
  borderRight: borderSideSchema(color).nullable().optional(),
  borderBottom: borderSideSchema(color).nullable().optional(),
  borderLeft: borderSideSchema(color).nullable().optional()
}).transform((v) => ({
  borderTop: v.borderTop,
  borderRight: v.borderRight,
  borderBottom: v.borderBottom,
  borderLeft: v.borderLeft
}));
const border = borderSchema(ResourceSchema.colorData);
const fontFamily = z.string().nullable().optional();
const letterSpacing = z.number().nullable().optional();
const fontSize = z.object({
  value: z.number(),
  unit: z.literal("px")
}).nullable().optional();
const fontWeight = z.number().nullable().optional();
const textTransform = z.array(z.literal("uppercase"));
const fontStyle = z.array(z.literal("italic"));
const textStyle = z.object({
  fontFamily: fontFamily.nullable().optional(),
  letterSpacing: letterSpacing.nullable().optional(),
  fontSize: fontSize.nullable().optional(),
  fontWeight: fontWeight.nullable().optional(),
  textTransform,
  fontStyle
}).transform((v) => ({
  ...v,
  letterSpacing: v.letterSpacing,
  fontWeight: v.fontWeight,
  fontSize: v.fontSize
}));
const width = z.union([pixelLength, percentageLength]);
const marginValue = z.union([pixelLength, z.literal("auto")]).nullable().optional();
const margin = z.object({
  marginTop: marginValue,
  marginRight: marginValue,
  marginBottom: marginValue,
  marginLeft: marginValue
}).transform((v) => ({
  ...v,
  marginTop: v.marginTop,
  marginRight: v.marginRight,
  marginBottom: v.marginBottom,
  marginLeft: v.marginLeft
}));
const paddingValue = pixelLength.nullable().optional();
const padding = z.object({
  paddingTop: paddingValue,
  paddingRight: paddingValue,
  paddingBottom: paddingValue,
  paddingLeft: paddingValue
}).transform((v) => ({
  ...v,
  paddingTop: v.paddingTop,
  paddingRight: v.paddingRight,
  paddingBottom: v.paddingBottom,
  paddingLeft: v.paddingLeft
}));
const borderRadiusValue = z.union([pixelLength, percentageLength]).nullable().optional();
const borderRadius = z.object({
  borderTopLeftRadius: borderRadiusValue,
  borderTopRightRadius: borderRadiusValue,
  borderBottomRightRadius: borderRadiusValue,
  borderBottomLeftRadius: borderRadiusValue
});
export {
  border,
  borderRadius,
  borderSchema,
  borderSide,
  borderSideSchema,
  borderStyle,
  fontFamily,
  fontSize,
  fontStyle,
  fontWeight,
  letterSpacing,
  margin,
  padding,
  percentageLength,
  pixelLength,
  resolvedBorderSide,
  textStyle,
  textTransform,
  width
};
//# sourceMappingURL=schema.js.map